<template>
<div>
<h1> Available cohorts </h1>
<div style='display: table; margin-right: auto; margin-left: auto;' v-html='cohorts'>
</div>
<br/>
<br/>
<br/>
</div>
</template>

<script>
export default {
  name: 'CohortView',
  props: {
    query_data: Object,
    cohorts: ''
  },
  data () {
    return {
      data: this.query_data
    }
  },
  mounted () {
    this.generateHTML()
  },
  methods: {
    findOcc (arr, key) {
      let arr2 = []
      arr.forEach((x) => {
        if (arr2.some((val) => { return val[key] === x[key] })) {
          arr2.forEach((k) => {
            if (k[key] === x[key]) {
              k['occurrence']++
            }
          })
        } else {
          let a = {}
          a[key] = x[key]
          a['occurrence'] = 1
          arr2.push(a)
        }
      })
      return arr2
    },

    generateHTML () {
      var occByName = this.findOcc(this.query_data, 'experiment')
      var cohorts = `
      <table>
      <tr>
      <th> Name of cohort </th>
      <th> Number of experiments </th>
      </tr>
      `
      occByName.forEach(function (name, index) {
        cohorts = cohorts.concat(`<tr> <td> ${name.experiment} </td> <td> ${name.occurrence} </td> </tr>`)
      })
      cohorts = cohorts.concat(`</table>`)
      this.cohorts = cohorts
    }
  }
}
</script>

<style>
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color:  #f48990;
  color: white;
}
tr:hover {background-color: #f48990; color: black; }
tr:hover:nth-child(even) { background-color: #f48990; color: black; }
tr:nth-child(even){background-color: #f2f2f2}
</style>



// WEBPACK FOOTER //
// src/components/CohortView.vue